export default __webpack_public_path__ + "static/media/youtube.d164e8db.svg";